import { Severity } from '@sentry/browser';
import { ParsedRequirementNode } from '../../../Common/Parsers/RequirementNodeParser';
import { SentryLogger } from '../../../sentryLogging/SentryLogger';
import { AotCategory, logConstants } from '../../../utils/Constants';
import Utils from '../../../utils/Utils';
import AuthMan from '../../AuthMan';
import { Logger } from '../../Logger';
import formsUIWrapper from './formsUIWrapper';
import { CloseFormsReason } from '../../../AccountConfig';

const formsAuthWebviewHandler = {
	//Shows form for authentication (if another request is not already being processed)
	async showForm(
		id: string,
		requirements: ParsedRequirementNode[],
		prepopulatedCredentials: string,
		referenceUri: string,
		timeoutSeconds: number | null
	): Promise<string> {
		Logger.getInstance().write(
			logConstants.INFO,
			id + ': showing login form.',
			AotCategory.Info,
			'Showing login form.'
		);
		SentryLogger.getInstance().addBreadCrumb({
			category: 'formsAuthWebviewHandler',
			level: Severity.Info,
			message: 'showing login form.',
		});
		return new Promise(
			function (resolve: Function, reject: Function): void {
				const request = AuthMan.getInstance().requestQueue.find((req) => req.id === id);
				request.webviewResolve = resolve;
				request.reject = reject;
				const utils = Utils.getInstance();
				const store = {
					url: utils.getHost(referenceUri),
					name: AuthMan.getInstance().getStoreName(referenceUri),
				};
				formsUIWrapper.showForm(
					requirements,
					prepopulatedCredentials,
					referenceUri,
					store,
					timeoutSeconds
				);
			}.bind(this)
		);
	},

	async updateForm(id: string, requirements: ParsedRequirementNode[]): Promise<string> {
		Logger.getInstance().write(logConstants.INFO, id + ': updating login form.');
		SentryLogger.getInstance().addBreadCrumb({
			category: 'formsAuthWebviewHandler',
			level: Severity.Info,
			message: 'updating login form.',
		});
		return new Promise(
			function (resolve: Function, reject: Function): void {
				const request = AuthMan.getInstance().requestQueue.find((req) => req.id === id);
				request.webviewResolve = resolve;
				request.reject = reject;
				formsUIWrapper.updateForm(requirements);
			}.bind(this)
		);
	},

	closeForm(id: string, reason: CloseFormsReason): void {
		Logger.getInstance().write(
			logConstants.INFO,
			id + ': closing login form.',
			AotCategory.Info,
			'Closing login form.'
		);
		SentryLogger.getInstance().addBreadCrumb({
			category: 'formsAuthWebviewHandler',
			level: Severity.Info,
			message: 'closing login form.',
		});
		formsUIWrapper.closeForm(reason);
	},
};
export default formsAuthWebviewHandler;
